<template>
    <el-card>
        <template #header>
            <div class="card-header">
                <span>设备状态分布</span>
            </div>
        </template>
        <div ref="chartRef" class="chart-canvas"></div>
    </el-card>
</template>

<script>
import * as echarts from 'echarts';

export default {
    props: {
        chartData: {
            type: Array,
            default: () => [{ value: 0, name: '在线' }, { value: 0, name: '离线' }]
        }
    },
    data() {
        return {
            chartInstance: null
        };
    },
    mounted() {
        this.initChart();
        window.addEventListener('resize', this.handleResize);
    },
    watch: {
        chartData: {
            deep: true,
            handler() {
                this.updateChart();
            }
        }
    },
    beforeDestroy() {
        if (this.chartInstance) {
            this.chartInstance.dispose();
        }
        window.removeEventListener('resize', this.handleResize);
    },
    methods: {
        initChart() {
            this.chartInstance = echarts.init(this.$refs.chartRef);
            this.updateChart();
        },
        updateChart() {
            const option = this.getChartOption('设备状态', this.chartData);
            this.chartInstance.setOption(option);
        },
        getChartOption(seriesName, chartData) {
            return {
                tooltip: { trigger: 'item' },
                legend: { top: 'bottom' },
                series: [{
                    name: seriesName,
                    type: 'pie',
                    radius: '60%',
                    itemStyle: {
                        borderRadius: 0,
                        borderColor: '#fff',
                        borderWidth: 2
                    },
                    label: {
                        show: true,
                        formatter: '{b}: {c} ({d}%)'
                    },
                    emphasis: { label: { show: true, fontSize: 20, fontWeight: 'bold' } },
                    data: chartData
                }]
            };
        },
        handleResize() {
            if (this.chartInstance) {
                this.chartInstance.resize();
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.card-header {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 600;
    color: #333;
}

.chart-canvas {
    width: 100%;
    height: 30vh;
}
</style>